
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Picker, Popup, Toast, Field } from 'vant';
import { rule, field, fieldCopy } from '../submit';
import Uploader from '../components/NewUploader.vue';
import { save, getUserList, detailUser } from '../api';
import { FileType } from '@/common/ts/enum';
import { isWeiXin } from '@/common/ts/common';
import { unionIdIsBind } from '@/api/api';
import qs from 'qs';

Vue.use(Picker).use(Popup).use(Toast).use(Field);
@Component({
  components: {
    Uploader,
  },
})
export default class Save extends Vue {
  maxTime = '60秒';
  list = rule;
  showPicker: boolean = false;
  pickerTile = '';
  field: any = {
    name: '',
    phone: '',
    company: '',
    work_type: '',
    title: '',
  };
  columns = [];
  pickerInx = -1;
  value = '';
  unionid: string | null = '';
  detailcontent: string = '';
  allow: boolean = true;
  idold = '';
  // cover = [];
  // facecover = [];
  // videolist = [];
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    const token = window.gettoken();
    if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游APP打开');
      return false;
    }
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if ((token === 'null' || !token) && window.udid) {
      setTimeout(() => {
        this.AppLogin();
      }, 500);
    }
    this.clearData();
    // this.checkIsBind();
    let id = this.$route.query.detailId;
    if (id) {
      this.idold = id + '';
      this.reshowinfo(id);
    }
  }
  // async checkIsBind() {
  //   const data = {
  //     type: 2,
  //     unionId: this.unionid,
  //   };
  //   if (window.udid) {
  //     this.AppLogin();
  //   } else if (isWeiXin()) {
  //     const res: any = await unionIdIsBind(data);
  //     if (!res.data) {
  //       this.$router.push(
  //         `/BindPhone?url=${encodeURIComponent(location.href)}`,
  //       );
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  // }
  async openPicker(data: any) {
    this.columns = data.columns;
    this.pickerTile = data.title;
    this.showPicker = true;
    this.value = data.value;
  }
  onConfirm(value: any, index: any) {
    this.showPicker = false;
    this.field[this.value] = value;
    this.pickerInx = index + 1;
    console.log(value, index, this.pickerInx);
  }
  onCancel() {
    this.showPicker = false;
  }
  async reshowinfo(id: any) {
    detailUser(id, window.localStorage.getItem('unionid')).then((res: any) => {
      console.log('id:', res);
      if (res.code === 200) {
        let cacheNCPFormData = res.data;
        this.field = res.data;
        this.detailcontent = cacheNCPFormData.detailcontent;
        if (cacheNCPFormData.work_type === '图文作品') {
          this.pickerInx = 1;
        } else {
          this.pickerInx = 2;
        }
        if (this.field.work_type === '图文作品') {
          if (cacheNCPFormData.cover) {
            this.field.cover = cacheNCPFormData.cover;
            this.field.cover.forEach((item: any) => {
              (this.$refs.uploaderImageList as Uploader).userHasUpload = true;
              (this.$refs.uploaderImageList as Uploader).presetFiles.push({
                cover: item,
                path: item,
                type: FileType.Image,
              });
            });
          }
        } else if (this.field.work_type === '视频作品') {
          if (cacheNCPFormData.cover) {
            this.field.facecover = cacheNCPFormData.cover;
            this.field.facecover.forEach((item: any) => {
              (this.$refs.uploaderImage as Uploader).userHasUpload = true;
              (this.$refs.uploaderImage as Uploader).presetFiles.push({
                cover: item,
                path: item,
                type: FileType.Image,
              });
            });
          }
          if (cacheNCPFormData.video) {
            this.field.video = cacheNCPFormData.video;
            this.field.video.forEach((item: any) => {
              (this.$refs.uploaderVideo as Uploader).userHasUpload = true;
              if (item.toLowerCase().endsWith('.mp4')) {
                (this.$refs.uploaderVideo as Uploader).presetFiles.push({
                  cover: 'https://act.cqrb.cn/2024h1/img/video.a1ba18ea.png',
                  path: item,
                  type: FileType.Image,
                });
              }
            });
          }
        } else {
          console.log('数据错误');
        }
      } else if (res.code === 202) {
        const token = window.gettoken();
        if (!this.unionid && isWeiXin()) {
          this.WechatLogin();
        } else if (!token && window.udid) {
          this.AppLogin();
        } else {
          Toast('请在微信或者上游APP打开');
          return false;
        }
      } else {
        Toast(res.msg);
        return false;
      }
    });
  }
  async getUpload(type: any) {
    switch (type) {
      case 1:
        (this.$refs.uploaderImageList as Uploader).uploadToOss().then((res) => {
          this.field.cover = res;
        });
        break;
      case 2:
        (this.$refs.uploaderImage as Uploader).uploadToOss().then((res) => {
          this.field.facecover = res;
        });
        break;
      case 3:
        (this.$refs.uploaderVideo as Uploader).uploadToOss().then((res) => {
          this.field.video = res;
        });
        break;
    }
    console.log(this.field);
  }
  clearData() {
    this.field = {};
    this.detailcontent = '';
    this.field.cover = [];
    this.field.facecover = [];
    this.field.video = [];
    this.pickerInx = -1;
  }
  async submit() {
    const token = window.gettoken();
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
      return;
    } else if ((token === 'null' || !token) && window.udid) {
      this.AppLogin();
      return;
    }
    console.log(this.field);
    if (!this.field.name || this.field.name === '') {
      Toast.fail('请输入姓名！');
      return;
    } else if (!/^1[345789][0-9]{9}$/.test(this.field.phone)) {
      Toast.fail('请输入正确的联系方式！');
      return;
    } else if (!this.field.company || this.field.company === '') {
      Toast.fail('请输入单位名称！');
      return;
    } else if (!this.field.work_type || this.field.work_type === '') {
      Toast.fail('请选择类型！');
      return;
    } else if (!this.field.title || this.field.title === '') {
      Toast.fail('请输入作品标题！');
      return;
    } else if (!this.field.detailcontent && this.detailcontent === '') {
      Toast.fail('请输入故事内容！');
      return;
    } else if (
      this.pickerInx === 1 &&
      (!this.field.cover ||
        this.field.cover === undefined ||
        this.field.cover.length === 0)
    ) {
      Toast.fail('请上传作品图！');
      return;
    } else if (
      this.pickerInx === 2 &&
      (!this.field.facecover ||
        this.field.facecover === undefined ||
        this.field.facecover.length === 0)
    ) {
      Toast.fail('请上传作品封面图！');
      return;
    } else if (
      this.pickerInx === 2 &&
      (!this.field.video ||
        this.field.video === undefined ||
        this.field.video.length === 0)
    ) {
      Toast.fail('请上传作品视频！');
      return;
    }
    this.field.udid = window.udid;
    this.field.appkey = window.appkey;
    this.field.unionid = localStorage.getItem('unionid');
    this.field.detailcontent = this.detailcontent;
    if (this.pickerInx === 1) {
      this.field.cover = this.field.cover.join('|');
    } else if (this.pickerInx === 2) {
      this.field.facecover = this.field.facecover.join('|');
      this.field.video = this.field.video.join('|');
    }
    this.field.id = this.idold;
    console.log(this.field);
    this.fSlideData();
  }
  async fSlideData() {
    if (!this.allow) {
      Toast.fail('请求提交中...');
      return false;
    }
    this.allow = false;
    setTimeout(() => {
      this.allow = true;
    }, 3000);
    const ret: any = await save(this.field);
    if (ret.code === 200) {
      Toast.success(ret.msg);
      setTimeout(() => {
        // this.$router.go(0);
        this.$router.push('user');
      }, 2000);
    } else {
      Toast.fail(ret.msg);
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        const option = {
          action: 'mUserLogin',
          data: '请先登录上游账号',
        };
        window.handleMessage(JSON.stringify(option));
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
